module.exports = __webpack_public_path__ + "img/sy-ly-logo.bfedfa4b.svg";